/**
 * GrapesJS Block Icon Enhancements
 * Adds modern SVG icons to existing blocks
 */

const BlockIcons = {
  // MJML Icons (Heroicons style)
  icons: {
    text: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
    </svg>`,

    button: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="6" width="18" height="12" rx="2" stroke-width="2"/>
      <path stroke-linecap="round" d="M9 12h6"/>
    </svg>`,

    image: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 15l-5-5L5 21"/>
    </svg>`,

    divider: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-width="2" d="M4 12h16"/>
    </svg>`,

    section: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
      <path stroke-linecap="round" stroke-width="2" d="M3 9h18M3 15h18"/>
    </svg>`,

    column: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="7" height="18" rx="1" stroke-width="2"/>
      <rect x="14" y="3" width="7" height="18" rx="1" stroke-width="2"/>
    </svg>`,

    group: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
      <path stroke-width="2" d="M9 3v18M15 3v18M3 9h18M3 15h18"/>
    </svg>`,

    spacer: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-width="2" d="M4 8v8M20 8v8"/>
      <path stroke-linecap="round" stroke-width="2" stroke-dasharray="2 2" d="M8 12h8"/>
    </svg>`,

    navbar: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="4" width="18" height="4" rx="1" stroke-width="2"/>
      <path stroke-linecap="round" stroke-width="2" d="M7 6h10"/>
    </svg>`,

    hero: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 17l3-3m0 0l3 3m-3-3v7"/>
    </svg>`,

    social: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <circle cx="12" cy="12" r="3" stroke-width="2"/>
      <circle cx="6" cy="12" r="1" fill="currentColor"/>
      <circle cx="18" cy="12" r="1" fill="currentColor"/>
      <path stroke-linecap="round" stroke-width="2" d="M12 3v2m0 14v2M3 12h2m14 0h2"/>
    </svg>`,

    carousel: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="6" y="4" width="12" height="16" rx="2" stroke-width="2"/>
      <path stroke-linecap="round" stroke-width="2" d="M9 12l3 3 3-3"/>
      <rect x="3" y="8" width="2" height="8" rx="1" fill="currentColor"/>
      <rect x="19" y="8" width="2" height="8" rx="1" fill="currentColor"/>
    </svg>`,

    wrapper: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
    </svg>`,

    raw: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
    </svg>`,

    accordion: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="4" width="18" height="4" rx="1" stroke-width="2"/>
      <rect x="3" y="10" width="18" height="4" rx="1" stroke-width="2"/>
      <rect x="3" y="16" width="18" height="4" rx="1" stroke-width="2"/>
      <path stroke-linecap="round" stroke-width="2" d="M7 6h10M7 12h4M7 18h10"/>
    </svg>`,

    table: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
      <path stroke-width="2" d="M3 9h18M3 15h18M9 3v18M15 3v18"/>
    </svg>`,

    // HTML-specific icons
    link: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
    </svg>`,

    video: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <rect x="3" y="5" width="18" height="14" rx="2" stroke-width="2"/>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9l5 3-5 3V9z" fill="currentColor"/>
    </svg>`,

    map: `<svg class="gjs-block-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
    </svg>`,
  },

  /**
   * Enhance a block with an icon
   * @param {Object} block - GrapesJS block instance
   * @param {string} iconName - Icon name from the icons object
   */
  enhanceBlock(block, iconName) {
    if (!block || !this.icons[iconName]) {
      return;
    }

    const currentLabel = block.get('label');
    const iconSvg = this.icons[iconName];

    // Create new label with icon
    const newLabel = `
      ${iconSvg}
      <div class="gjs-block-label">${currentLabel}</div>
    `;

    block.set('label', newLabel);
  },

  /**
   * Initialize and enhance all blocks with icons
   * @param {Object} editor - GrapesJS editor instance
   */
  init(editor) {
    // Wait for editor to load
    editor.on('load', () => {
      const blockManager = editor.BlockManager;

      // MJML blocks mapping
      const mjmlBlocks = {
        'mj-text': 'text',
        'mj-button': 'button',
        'mj-image': 'image',
        'mj-divider': 'divider',
        'mj-section': 'section',
        'mj-column': 'column',
        'mj-group': 'group',
        'mj-spacer': 'spacer',
        'mj-navbar': 'navbar',
        'mj-hero': 'hero',
        'mj-social': 'social',
        'mj-carousel': 'carousel',
        'mj-wrapper': 'wrapper',
        'mj-raw': 'raw',
        'mj-accordion': 'accordion',
        'mj-table': 'table',
      };

      // HTML blocks mapping
      const htmlBlocks = {
        'text': 'text',
        'button': 'button',
        'image': 'image',
        'video': 'video',
        'map': 'map',
        'link': 'link',
        'divider': 'divider',
        'sect100': 'section',
        'sect50': 'column',
        'sect30': 'column',
        'sect37': 'column',
      };

      // Apply icons to MJML blocks
      Object.entries(mjmlBlocks).forEach(([blockId, iconName]) => {
        const block = blockManager.get(blockId);
        if (block) {
          this.enhanceBlock(block, iconName);
        }
      });

      // Apply icons to HTML blocks
      Object.entries(htmlBlocks).forEach(([blockId, iconName]) => {
        const block = blockManager.get(blockId);
        if (block) {
          this.enhanceBlock(block, iconName);
        }
      });
    });
  },
};

// Export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BlockIcons;
} else {
  window.BlockIcons = BlockIcons;
}
